<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {onMount} from 'svelte';
    import moment from 'moment';
    import {sgettext} from '../../i18n.js';
    import BasicFormLayout from "../Form/BasicFormLayout.svelte";
    import {validateForm} from '../Form/utils.js';

    import yup, {object, number, string} from 'yup';
    import {submit} from "../../utils";

    export let item_type = 'ALL';
    export let title = 'Items';
    export let activityVersionId = null;
    export let activity_item_url = `${PATH_PREFIX}/sw/api/activity/${activityVersionId}/extra_items/${item_type}`;
    export let activity_items_url = `${PATH_PREFIX}/sw/api/activity/${activityVersionId}/extra_items/${item_type}/0/`;
    export let columns = [];
    export let addText = sgettext('$$ADD_ITEM$$');
    export let editable = true;

    let modalTitle = "Untitled!";

    let formId = "activity_item_form";

    let schema = object().shape({
        item_name: string().required(sgettext("$$PLEASE_ENTER_NAME$$")),
        item_description: string().required(sgettext("$$PLEASE_ENTER_DESCRIPTION$$")),
        item_count: number().required().typeError(sgettext("$$AMOUNT_MUST_NUMBER$$")) //.min(0, sgettext("$$LEAST_ITEM_REQUIRED$$"))
    });

    function setFields() {
        return {
            item_name: {
                label: sgettext(columns[0] + "*"),
                isValid: true,
                errors: null,
                type: 'text',
            },
            item_description: {
                label: sgettext(columns[1] + "*"),
                isValid: true,
                errors: null,
                type: 'text',
            },
            item_count: {
                label: sgettext(columns[2] + "*"),
                isValid: true,
                errors: null,
                type: 'text',
            },
        };
    }

    let fields = setFields();

    let formModel = {
        id: null,
        item_name: '',
        item_description: '',
        item_count: 0,
        expired: false,
        activity_version: activityVersionId,
        item_type: item_type
    };


    export let striped = true;
    let selectedRow = null;
    export let activity_items = [];

    export let fit_columns = true;

    const csrftoken = document.querySelector('[name=csrfmiddlewaretoken]').value;


    let filterValue = "";
    let filterValueEntry = "";
    let filteredActivityItems = [];

    $: {
        filteredActivityItems = activity_items.filter((value) => {
            if (filterValue == "") {
                return true;
            }
            if (filterValue == null) {
                return true;
            }
            let fv = filterValue.toLowerCase()
            return value.item_name.toLowerCase().includes(fv)
                    || value.item_description.toLowerCase().includes(fv);
        })
    }


    function clear(event) {
        filterValue = "";
        filterValueEntry = "";
    }

    function filterSelect(event) {
        filterValue = filterValueEntry;
    }


    async function retrieveItems() {
        const response = await fetch(activity_items_url);
        const json = await response.json();
        try {
            if (response.ok) {
                if (json) {
                    activity_items = json.results;
                }
            } else {
                console.error(json);
            }
        } catch (err) {
            console.error(err);
        }
        return activity_items;
    }

    async function submitForm(item) {
        try {
            await validateForm(schema, formModel);
            let action = 'POST'
            let url = activity_items_url;
            if (formModel.id) {
                url = activity_item_url.replace('/0/', `/${formModel.id}/`)
                action = 'PUT';
            }

            const response = await submit(url, action, formModel);
            const json = await response.json();
            try {
                if (response.ok) {
                    if (json) {
                        activity_items = await retrieveItems();
                        jQuery('#activity_item_modal').modal('hide');
                    }
                } else {
                    console.error(json);
                }
            } catch (err) {
                console.error(err);
            }
        } catch (err) {
            err.inner.forEach((er) => {
                fields[er.path].isValid = false;
                fields[er.path].errors = er.message;
            })
        }

        return activity_items;
    }

    async function editItem(item) {
        fields = setFields();
        jQuery('#activity_item_modal').modal('show');
        modalTitle = `Edit ${title}`;
        formModel = item;
    }

    async function addItem(item) {
        fields = setFields();
        jQuery('#activity_item_modal').modal('show')
        modalTitle = `Add ${title}`;
        formModel = {
            id: null,
            item_name: '',
            item_description: '',
            item_count: 0,
            expired: false,
            activity_version: activityVersionId,
            item_type: item_type
        };

    }

    async function deleteItem(item) {

        const form_data = new FormData();
        form_data.append('activity_item_id', item);
        try {
            await submit(activity_item_url.replace('/0/', `/${item}`), 'DELETE', form_data)
            activity_items = await retrieveItems();
        } catch (err) {
            console.error(err);
        }
        return activity_items;
    }

    function transformDateTime(dateTime) {
        var formattedDateTime = moment(dateTime);
        if (formattedDateTime.isValid()) {
            return formattedDateTime.format('MMM. DD, YYYY, h:mm A.');
        } else {
            return 'N/A';
        }
    }

    onMount(async () => {
        activity_items = await retrieveItems();
    });
</script>

<div class="container">

    <h1 class="text-primary">{sgettext(title)}</h1>
    <div>
        <form class="form-inline float-left" onsubmit="return false;" style="margin-bottom: 10px">

            <div class="form-group">
                <label class="control-label" for="id_keyword">
                    {sgettext('$$KEYWORD_1$$')}
                </label>
                <input type="text" name="keyword" class="form-control" required="" id="id_keyword"
                       bind:value={filterValueEntry}>
            </div>

            <div class="form-group">
                <!-- svelte-ignore a11y-invalid-attribute -->
                <a on:click={filterSelect} href="#" class="btn btn-outline">{sgettext('$$FILTER_1$$')}</a>

                <!-- svelte-ignore a11y-invalid-attribute -->
                <a on:click={clear} href="#" class="btn btn-outline">{sgettext('$$CLEAR_FILTER$$')}</a>

            </div>
        </form>
        <div class="float-right">
            <button type="button" class="btn btn-primary" class:d-none="{!editable}" data-toggle="modal" on:click={addItem}>
                {addText}
            </button>
        </div>
    </div>


    <table class="table" class:table-striped={striped}>
        <thead class="thead-light">
        <tr>
            {#each columns as col}
                <th class:fit={fit_columns}>
                    {col}
                </th>
            {/each}
            <th style="width:15%">{#if editable} {sgettext('$$COMMANDS$$')} {/if}</th>
        </tr>
        </thead>
        <tbody>
        {#each filteredActivityItems as ai}
            <tr>
                <td>
                    {ai.item_name}
                </td>
                <td>
                    {ai.item_description}
                </td>
                <td>
                    {ai.item_count}
                </td>
                <td>
                    {#if editable}
                        <button class="btn btn-sm btn-outline" on:click={() => editItem(ai)}>{sgettext("$$EDIT$$")}</button>
                        <button class="btn btn-sm btn-outline"
                                on:click={() => deleteItem(ai.id)}>{sgettext("$$EXPIRE$$")}</button>
                    {/if}
                    &nbsp;
                </td>
            </tr>
        {/each}
        </tbody>
    </table>


    <div id="activity_item_modal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{modalTitle}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <BasicFormLayout {formId} {schema} {fields} {formModel}/>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" on:click={submitForm}>{sgettext('$$SAVE_CHANGES_1$$')}</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">{sgettext('$$CLOSE$$')}</button>
                </div>
            </div>
        </div>
    </div>


</div>
